import React from "react";
import { useSEO } from "@/hooks/useSEO";
import { Section, SectionHeading, Reveal, CTASection, Eyebrow } from "@/components/ui-bits";
import { PageHero, FlowDiagram, CapabilityCard, PhotoPlaceholder } from "@/components/shared";
import { IMG, FACILITY_FLOW } from "@/lib/data";

const MACHINERY = [
  { title: "Material Preparation", desc: "Sifting and controlled material preparation.", icon: "Filter" },
  { title: "Blending", desc: "Consistent mixing of formulation components.", icon: "Blend" },
  { title: "Filling", desc: "Controlled filling into appropriate formats.", icon: "Container" },
  { title: "Sachet / Stick Pack", desc: "Single-serve packaging capability.", icon: "Package" },
  { title: "Quality Control", desc: "Checks throughout the manufacturing process.", icon: "ShieldCheck" },
];

export default function Manufacturing() {
  useSEO("Beverage Mix & Contract Manufacturing | Wisperwick Studio",
    "Contract manufacturing for beverage mixes and functional products — weighing, blending, filling and single-serve packaging under one partner.");
  return (
    <div>
      <PageHero eyebrow="The facility" title="Where ideas become products."
        sub="A premium presentation of the Wisperwick Studio manufacturing journey — from raw materials to finished goods." />

      <Section className="pt-0">
        <div className="grid sm:grid-cols-2 gap-5">
          <Reveal><PhotoPlaceholder src={IMG.facility1} alt="Wisperwick Studio blending and sieving equipment" label="WISPERWICK STUDIO — BLENDING & SIEVING" ratio="aspect-[3/2]" /></Reveal>
          <Reveal delay={0.08}><PhotoPlaceholder src={IMG.facility2} alt="Wisperwick Studio stick pack packaging area" label="WISPERWICK STUDIO — PACKAGING AREA" ratio="aspect-[3/2]" /></Reveal>
        </div>
        <Reveal delay={0.1}>
          <div className="mt-16">
            <p className="label text-ws-accent mb-6">The manufacturing journey</p>
            <FlowDiagram items={FACILITY_FLOW} />
          </div>
        </Reveal>
      </Section>

      <Section bg="var(--ws-bg2)">
        <SectionHeading eyebrow="Equipment & capability" title="The equipment behind the product."
          sub="Presented as capabilities. Machinery names and technical specifications are editable placeholders — replace with verified Wisperwick Studio equipment details." />
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5 mt-14">
          {MACHINERY.map((m, i) => <CapabilityCard key={m.title} item={m} index={i} />)}
          <Reveal delay={0.14}>
            <div className="h-full p-8 rounded-2xl border border-dashed border-ws-border bg-ws-card flex flex-col justify-center">
              <p className="label text-ws-text2">Editable placeholders</p>
              <p className="text-ws-dark mt-3 text-sm leading-relaxed">[MACHINE SPECIFICATION]<br/>[PRODUCTION CAPACITY]<br/>Add verified machinery details here.</p>
            </div>
          </Reveal>
        </div>
        <Reveal delay={0.1}><p className="mt-10 text-xs text-ws-text2 max-w-2xl">We do not publish facility size, production capacity, machine brands, machine speed, employee numbers or production volumes unless verified.</p></Reveal>
      </Section>

      <CTASection />
    </div>
  );
}
